import { Button } from '@southfields-digital/mpxlive-components';
import classNames from 'classnames';
import type { ComponentProps } from 'react';

type AdjustButtonProps = ComponentProps<typeof Button> & {
  isSquare?: boolean;
  isCompact?: boolean;
  icon?: string;
  className?: string;
};

const AdjustButton = ({
  icon,
  className,
  isSquare = false,
  isCompact = false,
  ...props
}: AdjustButtonProps) => (
  <Button
    color="darkGray"
    className={classNames(
      'h-9 w-10 !font-semibold !rounded justify-items-center !overflow-visible',
      isSquare && 'aspect-square w-fit',
      isCompact && '!h-7 !w-8 !text-xs',
      className
    )}
    iconProps={icon ? { icon: icon, weight: 'bold', size: isCompact ? 14 : 20 } : undefined}
    {...props}
  />
);

export default AdjustButton;
